import axios from "axios";
import store from "../../Redux/store";
import { Logout, RefreshToken } from "../Auth/Auth";
import { setAuthToken } from "../../Redux/AuthSlice/authSlice";

const API_PATH = process.env.REACT_APP_API_URL;

export interface ApiResponse<T = unknown> {
  data: T;
  error: string;
}

interface AxiosErrorWithConfig {
  config?: { retry?: boolean; url?: string; [key: string]: unknown };
  response?: { status: number };
  message?: string;
}

const sendDeleteCallToSever = (API_URL: string) => {
  return axios.delete(API_URL);
};

const sendPatchCallToSever = <T = unknown>(params: T, API_URL: string) => {
  return axios.patch(API_URL, params);
};

const sendPostCallToSever = <T = unknown>(
  params: T,
  API_URL: string,
  oposite = false
) => {
  if (oposite) return axios.patch(API_URL, params);
  else return axios.post(API_URL, params);
};

const sendGetCallToSever = (API_URL: string) => {
  return axios.get(API_URL);
};

axios.interceptors.request.use(
  function (config) {
    const apiPath = API_PATH;
    const url = config.url;
    const auth = store.getState().authSlice.auth_token;
    (config.headers as Record<string, string>) = {
      "content-type": "application/json",
      Authorization: "Bearer " + auth,
    };
    if (!(config as { retry?: boolean }).retry) config.url = apiPath + url;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    if (response) {
      const parsedData = response.data;
      if (response.status === 200 || response.status === 201) {
        return { ...response, data: parsedData } as any;
      } else {
        const errMsg = (response as any).error?.msg ?? "";
        return { ...response, data: {}, error: errMsg } as any;
      }
    }
    return response;
  },
  async function (error: AxiosErrorWithConfig) {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401) {
      try {
        // Attempt to refresh the token
        const dispatch = store.dispatch;
        const refreshToken = await RefreshToken();
        if (refreshToken) {
          dispatch(setAuthToken(refreshToken));
          // Token refresh successful, update the original request with the new token
          // originalRequest.headers.Authorization = `Bearer ${refreshToken}`;
          originalRequest.retry = true;

          return new Promise((resolve) => {
            resolve(axios(originalRequest));
          });
        } else {
          // Token refresh failed, redirect to logout
          Logout();
        }
      } catch (refreshError) {
        // An error occurred while refreshing the token, redirect to logout
        console.error("Token refresh error:", refreshError);
        Logout();
      }
    } else if (error.message && error.message === "Network Error") {
      console.log("network error: ", error);
    }
    // Propagate HTTP/API errors (4xx/5xx) so callers can treat failures correctly.
    // Resolving with `{ data: {} }` made failed requests look successful.
    return Promise.reject(error);
  }
);

export {
  sendPostCallToSever,
  sendGetCallToSever,
  sendDeleteCallToSever,
  sendPatchCallToSever,
};
